import React, { useMemo } from 'react';
import ToggleButtons from '../../../../Components/ToggleButtons/ToggleButtons';
import { ToggleButtonView } from '../../../../Enums/ToggleButtonView.enum';
import Button from '../../../../Components/Button/Button';
// @ts-ignore
import styles from './DENTToothQuickRestorationModal.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import {
	RESTORATION_BUTTON_OPTIONS,
	RestorationOption,
} from '../../Helpers/restoration/restorationButtonOptions';
import DENTModalOverviewRestorationCrown from '../DENTModalOverviewRestorationButtons/DENTModalOverviewRestorationCrown';
import DENTToothQuickRestorationModalFillingButtons from './DENTToothQuickRestorationModalFillingButtons';
import useTooth from '../../Hooks/Tooth/useTooth';
import DENTToothQuickRestorationModalVeneerButtons from './DENTToothQuickRestorationModalVeneerButtons';
import { ToothRestorationType } from '../../../../graphql/graphql';
import DENTToothQuickAdjustmentModalTitle from '../DENTToothQuickAdjustmentModal/DENTToothQuickAdjustmentModalTitle';

const DENTToothQuickRestorationModal = () => {
	const [selectedOption, setSelectedOption] =
		React.useState<RestorationOption>();
	const { handleUpdateTooth, activeTooth, originalActiveTooth } =
		useDENTContext();
	const {
		restoration: { setRestoration },
	} = useTooth();

	const selectedActionButtons = useMemo(() => {
		if (!selectedOption?.value) return null;

		switch (selectedOption.value) {
			case ToothRestorationType.Veneer:
			case ToothRestorationType.Onlay:
			case ToothRestorationType.Inlay:
			case ToothRestorationType.PartialCrown:
				return (
					<DENTToothQuickRestorationModalVeneerButtons
						restorationType={selectedOption.value}
					/>
				);
			case ToothRestorationType.Filling:
				return <DENTToothQuickRestorationModalFillingButtons />;
			case ToothRestorationType.Crown:
				return <DENTModalOverviewRestorationCrown />;
			default:
				return null;
		}
	}, [selectedOption]);

	const handleSubmit = async () => {
		if (!activeTooth?.restoration) return;
		handleUpdateTooth({
			restoration: activeTooth.restoration,
		});
	};

	const onChangeOption = (option: RestorationOption) => {
		const isOriginalType =
			option.value === originalActiveTooth?.restoration?.type;
		const originalProps = isOriginalType
			? originalActiveTooth?.restoration
			: {};

		setRestoration({
			type: option.value,
			...originalProps,
			surfaces: isOriginalType
				? originalActiveTooth?.restoration?.surfaces ?? []
				: [],
		});
		setSelectedOption(option);
	};

	if (!activeTooth) return null;

	return (
		<div className={styles.wrapper}>
			<DENTToothQuickAdjustmentModalTitle
				title={
					'patientTreatment.meddiDENT.dentalCross.overviewModal.restoration'
				}
			/>
			<ToggleButtons<RestorationOption>
				options={RESTORATION_BUTTON_OPTIONS[activeTooth.type]}
				selectedOption={selectedOption}
				onChange={onChangeOption}
				view={ToggleButtonView.HORIZONTAL_MULTILINE}
			/>
			{selectedActionButtons}
			<Button title={'base.shared.form.send'} onClick={handleSubmit} />
		</div>
	);
};

export default DENTToothQuickRestorationModal;
